import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// Using environment variables for security
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAPGD3q_ks1ho_AP7WcKo_KWTJvMITg8V0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "barberize-app.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "barberize-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "barberize-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1006636973573",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1006636973573:web:ff6019c62c61b6235a266c",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-2RBF81VH2C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;
